import Hero from "./components/Hero";

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50 text-foreground-950">
      <Hero />
    </main>
  );
}